import React, { FunctionComponent } from 'react';

import { Experiments } from '../../constants/experiments';
import { useDonationAmount } from '../../hooks';
import { DonateButton } from '../DonateButton/DonateButton';
import { DonationAmountSelector } from '../DonationAmountSelector/DonationAmountSelector';
import { Share } from '../SocialButtons/Share';

const FundraisingCTA: FunctionComponent = () => {
  // AB test: starting_donation_on_frp_with_amount_page
  // Can be removed when experiment has ended
  const { showDonationAmountVariant } = useDonationAmount();
  return (
    <>
      {/*  AB test: starting_donation_on_frp_with_amount_page
           Can be removed when experiment has ended */}
      {showDonationAmountVariant === 'B' && <DonationAmountSelector />}
      <DonateButton
        key="donateButton"
        className="jg-space-mrsm jg-space-mrn@lg jg-space-mbsm"
        trackingDataPageSection="FundraisingCTA"
        experiments={[
          // B2C_059 - donate to yourself v3
          // Can be removed when experiment has ended
          Experiments.b2c_059_donate_to_yourself_v3,
        ]}
        successType="StaticDonateButtonClick"
      />
      <Share successType="StaticShareButtonClick" />
    </>
  );
};

export default FundraisingCTA;
